export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-photos-805ea449acf56c99c5b1e011c33ac004.png";